import type { IconNode } from '../types';

/**
 * @name hat-baseball
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgM3YxIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNGMyLjggMCA1LjUuMyA4IC45VjEyYTggOCAwIDAgMC0xNiAwdjIuOWMyLjUtLjYgNS4yLS45IDgtLjkiIC8+CiAgPHBhdGggZD0iTTkgMTQuMVYxMGg2djQuMSIgLz4KICA8cGF0aCBkPSJNMi4zIDE4QTIgMiAwIDAgMCA0IDIxaC40bDEuNi0uNGEyNi40NCAyNi40NCAwIDAgMSAxMiAwbDEuNi40aC40YTIgMiAwIDAgMCAxLjctM2wtMS44LTMuMmEzOS45IDM5LjkgMCAwIDAtMTUuOCAwWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hat-baseball
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hatBaseball: IconNode = [
  ['path', { d: 'M12 3v1', key: '1asbbs' }],
  [
    'path',
    { d: 'M12 14c2.8 0 5.5.3 8 .9V12a8 8 0 0 0-16 0v2.9c2.5-.6 5.2-.9 8-.9', key: 'f2b449' },
  ],
  ['path', { d: 'M9 14.1V10h6v4.1', key: '17vz4k' }],
  [
    'path',
    {
      d: 'M2.3 18A2 2 0 0 0 4 21h.4l1.6-.4a26.44 26.44 0 0 1 12 0l1.6.4h.4a2 2 0 0 0 1.7-3l-1.8-3.2a39.9 39.9 0 0 0-15.8 0Z',
      key: 'xo2dry',
    },
  ],
];

export default hatBaseball;
